import React, { Fragment, useState } from "react";
import ReactPaginate from "react-paginate";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { styled } from "styled-components";
import QuestionContainer from "./QuestionContainer";
import TextQuestion from "../../components/survey/components/TextQuestion";
import FileQuestion from "../../components/survey/components/FileQuestion";
import MultiSelectQuestion from "../../components/survey/components/MultiSelectQuestion";
import TextBirthDateQuestion from "../../components/survey/components/TextBirthDateQuestion";
import ReadonlyTextBlock from "../../components/survey/components/ReadonlyTextBlock";
import RadioSelectQuestion from "../../components/survey/components/RadioSelectQuestion";
import NumberQuestion from "../../components/survey/components/NumberQuestion";
import DateQuestion from "../../components/survey/components/DateQuestion";
import GroupedQuestion from "../../components/survey/components/GroupedQuestion";
import AnalogQuestion from "../../components/survey/components/AnalogQuestion";

const StyledPaginate = styled(ReactPaginate).attrs({
  activeClassName: "active",
})`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  list-style-type: none;
  padding: 0 5rem;

  li a {
    border-radius: 7px;
    padding: 0.1rem 1rem;
    border: gray 1px solid;
    cursor: pointer;
  }
  li.previous a,
  li.next a,
  li.break a {
    border-color: transparent;
  }
  li.active a {
    background-color: #0366d6;
    border-color: transparent;
    color: white;
    min-width: 32px;
  }
  li.disabled a {
    color: grey;
  }
  li.disable,
  li.disabled a {
    cursor: default;
  }
`;

const renderQuestions = (
  collection,
  list,
  onAddCallback,
  onAddBundleCallback,
  onSwapCallback,
  onRemoveCallback,
  onUpdateCallback,
  onStartUpdatingQuestionCallback,
  ignoreBundles = false,
  suppressNonDiscreteQuestions = false,
  showScoreEntry,
  languageId,
) => {
  if (list) {
    var rendered = new Array();
    var counter = 0;
    var displayCount = 0;
    collection.map((node, i) => {
      counter++;
      if (node.data.questionType !== 8) {
        displayCount++;
      }

      switch (node.data.questionType) {
        case 6:
          rendered.push(
            <QuestionContainer
              node={node}
              position={counter}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <NumberQuestion
                question={node.data}
                position={counter}
                key={node.data.id}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 5:
          rendered.push(
            <QuestionContainer
              node={node}
              position={counter}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <TextQuestion
                question={node.data}
                position={counter}
                key={node.data.id}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        // case 4:
        // 	rendered.push(
        // 		<QuestionContainer
        // 			node={node}
        // 			position={counter}
        // 			list={list}
        // 			key={node.data.id}
        // 			onAddCallback={onAddCallback}
        // 			onAddBundleCallback={onAddBundleCallback}
        // 			onSwapCallback={onSwapCallback}
        // 			onRemoveCallback={onRemoveCallback}
        // 			onUpdateCallback={onUpdateCallback}
        // 			ignoreBundles={ignoreBundles}
        // 			onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
        // 			suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
        // 			showScoreEntry={showScoreEntry}
        // 			languageId={languageId}
        // 		>
        // 			<TFQuestion
        // 				question={node.data}
        // 				position={counter}
        // 				key={node.data.id}
        // 				positionDisplay={displayCount}
        // 				showScoreEntry={showScoreEntry}
        // 			/>
        // 		</QuestionContainer>
        // 	)
        // 	break
        case 7:
          rendered.push(
            <QuestionContainer
              node={node}
              position={counter}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <DateQuestion
                question={node.data}
                position={counter}
                key={node.data.id}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 2:
          rendered.push(
            <QuestionContainer
              node={node}
              position={counter}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <MultiSelectQuestion
                question={node.data}
                position={counter}
                key={node.data.id}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 8:
          rendered.push(
            <QuestionContainer
              node={node}
              position={counter}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <ReadonlyTextBlock
                question={node.data}
                position={counter}
                key={node.data.id}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 1:
          rendered.push(
            <QuestionContainer
              node={node}
              position={counter}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <RadioSelectQuestion
                question={node.data}
                position={counter}
                key={node.data.id}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 7:
          rendered.push(
            <QuestionContainer
              position={counter}
              node={node}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <TextBirthDateQuestion
                question={node.data}
                key={node.data.id}
                position={counter}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 3:
          rendered.push(
            <QuestionContainer
              position={counter}
              node={node}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <GroupedQuestion
                question={node.data}
                key={node.data.id}
                position={counter}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 9:
          rendered.push(
            <QuestionContainer
              position={counter}
              node={node}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <AnalogQuestion
                question={node.data}
                key={node.data.id}
                position={counter}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
              />
            </QuestionContainer>,
          );
          break;
        case 10:
        case 11:
          rendered.push(
            <QuestionContainer
              node={node}
              position={counter}
              list={list}
              key={node.data.id}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onRemoveCallback={onRemoveCallback}
              onUpdateCallback={onUpdateCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            >
              <FileQuestion
                question={node.data}
                position={counter}
                key={node.data.id}
                positionDisplay={displayCount}
                showScoreEntry={showScoreEntry}
                disabled={true}
              />
            </QuestionContainer>,
          );
          break;
      }
    });
    return rendered;
  }
  return new Array(0);
};

const BuilderContainer = ({
  headerTitle,
  onAddCallback,
  onAddBundleCallback,
  onSwapCallback,
  onRemoveCallback,
  onUpdateCallback,
  onStartUpdatingQuestionCallback,
  ignoreBundles,
  list,
  collection,
  suppressNonDiscreteQuestions = false,
  showPreview = true,
  showScoreEntry,
  languageId,
}) => {
  const itemsPerPage = 100;
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = collection?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(collection?.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % collection?.length;
    setCurrentPage(event.selected);

    setItemOffset(newOffset);
  };

  return (
    <Fragment>
      <Grid container direction="column">
        <Grid item>
          <Grid container justify="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h6">{headerTitle}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {collection && collection.length > 0 ? (
            <div>
              <StyledPaginate
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount > 1 ? pageCount : 0}
                previousLabel="< previous"
                breakLabel="..."
                initialPage={Math.ceil(itemOffset / itemsPerPage)}
                renderOnZeroPageCount={null}
                forcePage={currentPage}
              />
              {renderQuestions(
                currentItems,
                list,
                onAddCallback,
                onAddBundleCallback,
                onSwapCallback,
                onRemoveCallback,
                onUpdateCallback,
                onStartUpdatingQuestionCallback,
                suppressNonDiscreteQuestions,
                ignoreBundles,
                showScoreEntry,
                languageId,
              )}
              <StyledPaginate
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount > 1 ? pageCount : 0}
                previousLabel="< previous"
                breakLabel="..."
                initialPage={Math.ceil(itemOffset / itemsPerPage)}
                renderOnZeroPageCount={null}
                forcePage={currentPage}
              />
            </div>
          ) : (
            <QuestionContainer
              list={list}
              suppressNonDiscreteQuestions={suppressNonDiscreteQuestions}
              onAddCallback={onAddCallback}
              onAddBundleCallback={onAddBundleCallback}
              onSwapCallback={onSwapCallback}
              onUpdateCallback={onUpdateCallback}
              onRemoveCallback={onRemoveCallback}
              ignoreBundles={ignoreBundles}
              onStartUpdatingQuestionCallback={onStartUpdatingQuestionCallback}
              showScoreEntry={showScoreEntry}
              languageId={languageId}
            />
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default BuilderContainer;
